import { create } from "zustand";
import { createJSONStorage, persist, subscribeWithSelector } from "zustand/middleware";
import { ConfigSlice, createConfigSlice } from "./slices/config";
import { createLayoutSlice, LayoutSlice } from "./slices/layout";
import { createPeerSessionSlice, PeerSessionSlice } from "./slices/peerSession";
import { createProgressBarSlice, ProgressBarSlice } from "./slices/progressBar";
import { createSessionSlice, SessionInfoSlice } from "./slices/sessionInfo";
import { createUserInfoSlice, UserInfoSlice } from "./slices/userInfo";

export type Storage = SessionInfoSlice &
	ConfigSlice &
	LayoutSlice &
	ProgressBarSlice &
	UserInfoSlice &
	PeerSessionSlice;

export const useStore = create<Storage>()(
	subscribeWithSelector(
		persist(
			(...a) => ({
				...createSessionSlice(...a),
				...createConfigSlice(...a),
				...createLayoutSlice(...a),
				...createProgressBarSlice(...a),
				...createUserInfoSlice(...a),
				...createPeerSessionSlice(...a),
			}),
			{
				name: "store",
				storage: createJSONStorage(() => sessionStorage),
			},
		),
	),
);
